function waitForTeamatical(callback) {
  if (window.Teamatical?.app?.inputs) {
    callback(window.Teamatical.app);
    return;
  }
  setTimeout(() => waitForTeamatical(callback), 200);
}

function getLbProductProperty() {
  const widget = document.querySelector("lb-upsell-widget");
  if (!widget) return null;
  const productId = widget.getAttribute("lb-trigger-product-id");
  const offer = widget.getAttribute("offer");
  if (!productId || !offer) return null;
  return `${productId}#${offer}`;
}

function getBundleItems(jerseyVariantId) {
  // Identify jersey cards: any card whose variant picker contains the selected
  // jersey variant as an option. This covers cases where the user changed size
  // after page load (card picker may still show the initial variant).
  const jerseyCards = new Set();
  document.querySelectorAll("lb-upsell-long-card").forEach(card => {
    const select = card.querySelector("select.lb-variant-picker");
    if (select) {
      if (select.querySelector(`option[value="${jerseyVariantId}"]`)) jerseyCards.add(card);
    } else {
      if (parseInt(card.getAttribute("lb-variant-id")) === jerseyVariantId) jerseyCards.add(card);
    }
  });

  const lbProduct = getLbProductProperty();
  const properties = lbProduct ? { "_lb-product": lbProduct } : {};

  const items = [];
  document.querySelectorAll("lb-upsell-long-card").forEach(card => {
    if (jerseyCards.has(card)) return;
    const checkbox = card.querySelector(".lb-card-checkbox");
    if (checkbox && !checkbox.checked) return;
    const select = card.querySelector("select.lb-variant-picker");
    const variantId = select
      ? parseInt(select.value)
      : parseInt(card.getAttribute("lb-variant-id"));
    if (variantId) items.push({ id: variantId, quantity: 1, properties });
  });
  return items;
}

const _origFetch = window.fetch.bind(window);
let _ourAdd = false;
let _teamaticalApp = null;
let _blockingForLb = false;
let _isProcessing = false;

waitForTeamatical((app) => {
  _teamaticalApp = app;
  console.log("[selleasy-override] Teamatical listo");
});

// Deshabilitar el botón de bundle mientras SellEasy termina su init asíncrono
// (lbPayload y lbupsellToken). Evita que el usuario haga clic antes de que el
// descuento esté disponible, lo que causaba que la primera compra no lo aplicara.
(async () => {
  const btn = await waitFor(() => document.querySelector(".lb-button"), 10000);
  if (!btn) return;

  btn.style.opacity = "0.5";
  btn.style.pointerEvents = "none";
  btn.style.cursor = "not-allowed";

  const widget = document.querySelector("lb-upsell-widget");
  await Promise.all([
    waitFor(() => widget?.lbPayload?.widget, 10000),
    waitFor(() => window.lbupsellToken, 10000),
  ]);

  btn.style.opacity = "";
  btn.style.pointerEvents = "";
  btn.style.cursor = "";
  console.log("[selleasy-override] Botón habilitado — SellEasy listo");
})();

// Activar el bloqueo en mousedown para que esté activo antes de que cualquier
// listener de click (incluyendo SellEasy) tenga oportunidad de hacer fetch.
// Solo bloquea cuando el click viene de .lb-button.
// mouseup/contextmenu reset the flag so a right-click doesn't leave it stuck.
document.addEventListener("mousedown", (e) => {
  _blockingForLb = !!e.target.closest(".lb-button");
}, { capture: true });

document.addEventListener("mouseup",     () => { if (!_isProcessing) _blockingForLb = false; }, { capture: true });
document.addEventListener("contextmenu", () => { _blockingForLb = false; },                    { capture: true });

function _shouldBlock() {
  return _teamaticalApp && !_ourAdd && _blockingForLb;
}

// ─── Bloqueo ──────────────────────────────────────────────────────────────────

// Fetch
window.fetch = function(url, options) {
  if (_shouldBlock() && typeof url === "string" && url.includes("/cart/add")) {
    console.log("[selleasy-override] fetch /cart/add bloqueado");
    return Promise.resolve(
      new Response('{"items":[]}', { status: 200, headers: { "Content-Type": "application/json" } })
    );
  }
  return _origFetch(url, options);
};

// XHR (jQuery.ajax, ShopifyAPI.addItemFromForm, etc.)
const _origXHROpen = XMLHttpRequest.prototype.open;
const _origXHRSend = XMLHttpRequest.prototype.send;

XMLHttpRequest.prototype.open = function(method, url) {
  this._isCartAdd = typeof url === "string" && url.includes("/cart/add");
  return _origXHROpen.apply(this, arguments);
};

XMLHttpRequest.prototype.send = function(body) {
  if (_shouldBlock() && this._isCartAdd) {
    console.log("[selleasy-override] XHR /cart/add bloqueado");
    const xhr = this;
    setTimeout(() => {
      try {
        Object.defineProperty(xhr, "readyState",   { get: () => 4, configurable: true });
        Object.defineProperty(xhr, "status",       { get: () => 200, configurable: true });
        Object.defineProperty(xhr, "responseText", { get: () => '{"items":[]}', configurable: true });
        if (xhr.onreadystatechange) xhr.onreadystatechange();
        xhr.dispatchEvent(new ProgressEvent("load"));
      } catch (e) {}
    }, 0);
    return;
  }
  return _origXHRSend.apply(this, arguments);
};

// Form submit
document.addEventListener("submit", (e) => {
  if (_shouldBlock() && e.target?.action?.includes("/cart/add")) {
    console.log("[selleasy-override] form submit /cart/add bloqueado");
    e.preventDefault();
    e.stopImmediatePropagation();
  }
}, { capture: true });

// ─── Helpers ──────────────────────────────────────────────────────────────────
// Espera hasta que condition() retorne un valor truthy, o hasta el timeout.
// Resuelve con el valor o con null si se agota el tiempo.
function waitFor(condition, timeout = 5000) {
  return new Promise(resolve => {
    const result = condition();
    if (result) return resolve(result);
    const start = Date.now();
    const interval = setInterval(() => {
      const result = condition();
      if (result) {
        clearInterval(interval);
        resolve(result);
      } else if (Date.now() - start > timeout) {
        clearInterval(interval);
        resolve(null);
      }
    }, 100);
  });
}

// ─── Descuento SellEasy ───────────────────────────────────────────────────────
// Soporta los métodos "function" (Selleasy discount functions) y "custom"
// (already existing discount code). Ambos usan un código estático configurado
// en el offer, que se aplica al carrito via Storefront API GraphQL.
//
// En la primera carga, SellEasy inicializa de forma asíncrona: lbPayload y
// lbupsellToken pueden no estar disponibles aún cuando el usuario hace clic.
// waitFor() hace polling hasta que ambos estén listos (máx 5s cada uno).
async function applySelleasyDiscount(cart) {
  const widget = document.querySelector("lb-upsell-widget");
  if (!widget) return;

  // Esperar a que SellEasy termine de setear lbPayload en el widget
  const payload = await waitFor(() => widget.lbPayload?.widget);
  const discounts = payload?.discounts;
  if (!discounts?.code || !["function", "custom"].includes(discounts.method)) return;

  // Esperar a que SellEasy setee el Storefront Access Token
  const lbupsellToken = await waitFor(() => window.lbupsellToken);
  if (!lbupsellToken) {
    console.warn("[selleasy-override] lbupsellToken no disponible — descuento omitido");
    return;
  }
  if (!cart?.token) return;

  const cartId = `gid://shopify/Cart/${cart.token}`;
  const existingCodes = (cart.discount_codes || [])
    .filter(d => d.applicable)
    .map(d => d.code);
  const allCodes = [...new Set([discounts.code, ...existingCodes])];

  const mutation = `
    mutation cartDiscountCodesUpdate($id: ID!, $discountCodes: [String!]) {
      cartDiscountCodesUpdate(cartId: $id, discountCodes: $discountCodes) {
        cart { id }
        userErrors { field message }
      }
    }
  `;

  try {
    const res = await _origFetch(`https://${window.location.hostname}/api/2025-07/graphql.json`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": lbupsellToken,
      },
      body: JSON.stringify({
        query: mutation,
        variables: { discountCodes: allCodes, id: cartId },
      }),
    });
    const result = await res.json();
    const errors = result?.data?.cartDiscountCodesUpdate?.userErrors;
    if (errors?.length) {
      console.warn("[selleasy-override] userErrors al aplicar descuento:", errors);
    } else {
      console.log("[selleasy-override] Descuento aplicado:", allCodes);
    }
  } catch (err) {
    console.error("[selleasy-override] Error aplicando descuento via GraphQL:", err);
  }
}

// ─── Handler principal ────────────────────────────────────────────────────────
window.addEventListener("click", async (e) => {
  const btn = e.target.closest(".lb-button");
  if (!btn) return;

  // Guard contra double-click y clics concurrentes.
  // btn.disabled no frena eventos en custom elements (div/span con clase .lb-button),
  // por eso usamos un flag independiente.
  if (_isProcessing) return;
  _isProcessing = true;

  e.stopImmediatePropagation();
  e.preventDefault();

  const originalHTML = btn.innerHTML;
  btn.disabled = true;
  btn.textContent = "Adding...";

  try {
    // Esperar Teamatical con timeout de 10s. El await está dentro del try para
    // que cualquier fallo (timeout incluido) llegue al finally y restaure el botón.
    const app = _teamaticalApp ?? await Promise.race([
      new Promise(resolve => waitForTeamatical(resolve)),
      new Promise((_, reject) => setTimeout(
        () => reject(new Error("Teamatical no cargó a tiempo (10s)")), 10000
      )),
    ]);
    const player = app.state.get("player");
    if (!player) throw new Error("Teamatical player data not available");

    const jerseyVariantId =
      document.querySelector('input[name="id"], select[name="id"]')?.value ||
      window.ShopifyAnalytics?.meta?.selectedVariantId;

    if (!jerseyVariantId) throw new Error("No se encontró variant ID del jersey");

    const lbProduct = getLbProductProperty();
    const jerseyProperties = {
      "Player Name":   player.name,
      "Player Number": player.number,
      ...(lbProduct ? { "_lb-product": lbProduct } : {}),
    };

    const bundleItems = getBundleItems(parseInt(jerseyVariantId));
    console.log("[selleasy-override] Bundle items a agregar:", bundleItems);

    _ourAdd = true;

    // Fetchear carrito para verificar si el jersey ya existe.
    const cartRes = await _origFetch("/cart.js");
    const cart = await cartRes.json();

    // ── Jersey ────────────────────────────────────────────────────────────────
    // Shopify suma automáticamente si variant_id + properties son idénticos.
    // Si las properties difieren (distinto jugador), crea un nuevo line item.
    // Si llega 422 (cantidad máxima), actualizamos las propiedades del existente.
    const jerseyAddRes = await _origFetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: [{ id: parseInt(jerseyVariantId), quantity: 1, properties: jerseyProperties }] }),
    });

    if (!jerseyAddRes.ok) {
      if (jerseyAddRes.status === 422) {
        // No se puede agregar más unidades — buscar el line item existente
        // por variant_id y actualizar sus propiedades.
        const freshCart = await _origFetch("/cart.js").then(r => r.json());
        const existingLine = (freshCart?.items || []).find(
          item => item.variant_id === parseInt(jerseyVariantId)
        );
        if (existingLine) {
          const changeRes = await _origFetch("/cart/change.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: existingLine.key, properties: jerseyProperties }),
          });
          if (!changeRes.ok) {
            const errBody = await changeRes.text().catch(() => "");
            throw new Error(`Error actualizando jersey ${changeRes.status}: ${errBody}`);
          }
        }
      } else {
        const errBody = await jerseyAddRes.text().catch(() => "");
        throw new Error(`Error agregando jersey ${jerseyAddRes.status}: ${errBody}`);
      }
    }

    // ── Bundle items ──────────────────────────────────────────────────────────
    // Shopify suma si variant_id + properties son idénticos (mismo talle y _lb-product).
    // Si el item está al máximo (422), se saltea sin abortar la operación.
    for (const item of bundleItems) {
      const addRes = await _origFetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: [item] }),
      });
      if (!addRes.ok) {
        if (addRes.status === 422) {
          console.warn("[selleasy-override] Item bundle al máximo, se saltea:", item.id);
        } else {
          const errBody = await addRes.text().catch(() => "");
          throw new Error(`Error agregando bundle item ${addRes.status}: ${errBody}`);
        }
      }
    }

    // Fetchear carrito DESPUÉS de agregar todos los items.
    // El Storefront API de Shopify requiere que el carrito tenga items para
    // que su token sea válido en cartDiscountCodesUpdate. En la primera visita,
    // el cart pre-add puede no tener un objeto Storefront API asociado aún.
    // Esto replica exactamente el comportamiento de SellEasy (mutateDiscount
    // siempre recibe el carrito post-add).
    const cartForDiscount = await _origFetch("/cart.js").then(r => r.json());
    await applySelleasyDiscount(cartForDiscount);

    // Redirect with discount code as URL parameter — reliable fallback that
    // guarantees Shopify applies the discount even if the Storefront API
    // GraphQL mutation above didn't take effect (e.g. brand-new cart on first
    // page visit where the AJAX cart hasn't been linked to a Storefront API
    // cart entity yet).
    const _widget = document.querySelector("lb-upsell-widget");
    const _discountCode = _widget?.lbPayload?.widget?.discounts?.code;
    const _redirectUrl = _discountCode
      ? `/cart?discount=${encodeURIComponent(_discountCode)}`
      : "/cart";
    window.location.href = _redirectUrl;

  } catch (err) {
    console.error("[selleasy-override] Error al agregar al carrito:", err);
    alert("There was an error adding to cart. Please try again.");
  } finally {
    _isProcessing = false;
    _ourAdd = false;
    _blockingForLb = false;
    btn.disabled = false;
    btn.innerHTML = originalHTML;
  }
}, { capture: true });

console.log("[selleasy-override] Inicializado");
